<template>
  <div class="addQualityTracing">
    <div class="content-form-container">
      <!-- 基础信息 -->
      <div class="main-container-form">
        <section class="head-title clearfix">
          <div class="titleForm-container">基础信息</div>
        </section>
        <el-form :model="info" :rules="rules" label-width="90px" ref="info" >
          <el-form-item label="基地选择" prop="fishBase">
            <el-select v-model="info.fishBase" :disabled="baseFieldsLocked || !edit" placeholder="请选择" size="medium" style="width:100%;" @change="changeBase">
              <el-option v-for="item in baseList" :key="item.id" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="塘口选择" prop="fishPond">
            <el-select v-model="info.fishPond" :disabled="baseFieldsLocked || !edit" placeholder="请选择" size="medium" style="width:100%;" @change="changePond">
              <el-option v-for="item in pondList" :key="item.id" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="周期" prop="fishBatchId">
            <el-select v-model="info.fishBatchId" :disabled="baseFieldsLocked || !edit" placeholder="请选择" size="medium" style="width:100%;" @change="changeCycle">
              <el-option v-for="item in batchList" :key="item.id" :label="item.fishBatch" :value="item.id" >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品种" prop="productId">
            <el-select v-model="info.productId" :disabled="baseFieldsLocked || !edit" placeholder="请选择" size="medium" style="width:100%;" @change="changeVariety">
              <el-option v-for="item in fishList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item  label="截止日期"  prop="endDate" class="time">
            <el-date-picker type="date" :disabled="baseFieldsLocked || !edit" placeholder="选择日期" :clearable="false"  value-format="yyyy-MM-dd"  :picker-options="pickerTimeOptions" v-model="info.endDate" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <inspect-component :qualityInspections="info.qualityInspections" :can-edit="edit" @addInspect="addInspect" @getInspect="getInspect" :isHideUpload='isHideUpload'></inspect-component>
      <driver-component :logistics="info.logistics" :can-edit="edit"></driver-component>
      <dealer-component :dealers="info.dealers" :can-edit="edit" @addDealer="addDealer" @getDealer="getDealer"></dealer-component>
    </div>
    <div class="save-cancel" v-if="edit">
      <el-button class="save-btn" @click="saveBase('info')" :loading="loadingtype">保存</el-button>
      <el-button class="cancel-btn" @click="cancelForm('info')">取消</el-button>
    </div>
  </div>

</template>


<script>
import { MessageBox, Message } from "element-ui";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
import InspectComponent from "../qualityTracing/InspectComponent";
import DealerComponent from "../qualityTracing/DealerComponent";
import DriverComponent from "../qualityTracing/DriverComponent";
import Utils from "../../../assets/js/guid";
import mixins from "@/common/MixIn.js";
export default {
  name: "addQualityTracing",
  mixins: [mixins],
  components: { InspectComponent, DealerComponent, DriverComponent },
  data() {
    return {
      isHideUpload: false,
      loadingtype: false,
      baseFieldsLocked: Boolean(this.$route.query.traceCode),
      starts: "",
      ends: "",
      cleareds: "",
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      uploadURl: imgUpload.imgUpload, // 文件上传地址
      num20: 20,
      num11: 11,
      num30: 30,
      companyUser: [], //负责人
      citys: [],
      countys: [],
      batchList: [],
      baseList: [], //基地列表
      pondList: [], //塘口列表
      cycleList: [], //周期列表
      fishList: [], // 塘口下渔种
      baseForm: {
        name: "",
        leaderId: "", // 联系人
        phone: "",
        detail: "" // 详细地址
      },
      info: {
        // 基础信息
        fishBase: "",
        fishPond: "",
        code: "", //追溯码
        endDate: new Date(), //截至时间
        productName: "", //产品名称
        submitter: "111", //提交人
        productId: null, //产品Id
        fishBatchId: null, //批次Id
        // 质检信息
        qualityInspections: [],
        // 物流信息
        logistics: [],
        // 流通商信息
        dealers: [],
        cultureInfo: {}
      },
      rules: {
        fishBase: [
          { required: true, message: "请先选择基地", trigger: "change" }
        ],
        fishPond: [{ required: true, message: "请先选择塘口" }],
        fishBatchId: [{ required: true, message: "请先选择周期" }],
        productId: [{ required: true, message: "请先选择品种" }],
        endDate: [
          {
            required: true,
            message: "请选择截止日期",
            trigger: "change"
          }
        ],
        qualityInfo: {},
        logisticsInfo: {},
        circulatorInfo: {
          company: [
            {
              required: true,
              message: "请先选择负责人",
              trigger: "change"
            }
          ],
          leader: [
            {
              required: true,
              message: "请先选择负责人",
              trigger: "change"
            }
          ],
          phone: [
            { required: true, message: "请先填写联系电话" },
            { type: "number", message: "联系电话必须为数字" },
            {
              pattern: /^1[3|4|5|7|8|9][0-9]\d{4,8}$/,
              message: "联系电话格式不对,请重新输入"
            }
          ],
          range: [
            { required: true, message: "请先输入详细地址", trigger: "blur" }
            // {
            //   pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+$/,
            //   message: "详细地址格式不对,请重新输入",
            //   min: 2
            // }
          ]
        }
      }
    };
  },
  computed: {
    ...mapState(["loginUser"])
  },
  async mounted() {
    await this.initPagePermission();
    if (this.$route.query.traceCode) {
      this.detailInit();
      document.title = "编辑追溯码";
    } else {
      document.title = "添加追溯码";
    }
    this.init();
  },
  methods: {
    ...mapActions(modules.cultureCycle, [
      "getCycleList" //分页查询周期
    ]),
    ...mapActions(modules.qualityTracing, {
      addQualityTracing: "addQualityTracing",
      getQualityTracingCode: "getQualityTracingCode",
      getInfoByTracingCode: "getInfoByTracingCode",
      editTracingCode: "editTracingCode" //修改追溯码
    }),
    ...mapActions(modules.base, {
      getBaseList: "getBaseList" //基地
    }),
    ...mapActions(modules.pond, {
      getFishPond: "getFishPond" //塘口
    }),
    ...mapActions(modules.fishSales, {
      getPondUnclearedBatchNo: "getPondUnclearedBatchNo" //周期批次
    }),
    ...mapActions(modules.fish, {
      getPondFishList: "getPondFishList" //塘口下的渔种
    }),
    // 初始化---基地
    async init() {
      this.baseList = await this.getBaseList();
    },
    detailInit() {
      this.getInfoByTracingCode({
        code: this.$route.query.traceCode
      }).then(async data => {
        console.log(data);
        this.info.fishBase = data.fishBaseId;

        this.info.code = data.code;
        this.info.endDate = data.endDate;
        this.info.productName = data.productName;
        this.info.submitter = data.submitter;
        this.info.qualityInspections = data.qualityInspections;
        console.log(88888);
        this.info.logistics = data.logistics;
        this.info.dealers = data.dealers;
        this.info.cultureInfo = data.cultureInfo;
        // 基地列表
        this.baseList = await this.getBaseList();
        let obj = this.baseList.find(item => {
          console.log(item, this.info.fishBase);
          return item.key == this.info.fishBase;
        });
        if (obj) {
          // 塘口列表
          this.pondList = await this.getFishPond(obj.key);
          this.info.fishPond = data.pondId;
          let pond = this.pondList.find(item => {
            return item.key == this.info.fishPond;
          });
          if (pond) {
            let obj = {
              fishPondId: pond.key,
              startDate: this.starts,
              endDate: this.ends,
              cleared: this.cleareds,
              pageIndex: 1,
              pageSize: 10000
            };
            // 周期列表
            let list = await this.getCycleList(obj);
            this.batchList = list.data.list;
            this.info.fishBatchId = data.fishBatchId;
            let cycle = this.batchList.find(item => {
              return item.id == this.info.fishBatchId;
            });
            if (cycle) {
              // 渔品种
              this.info.productId = data.productId;
              this.info.fishBatchId = cycle.id;
              this.fishList = await this.getPondFishList(cycle.id);
            }
          }
        }
      });
    },

    //获取流通商信息
    getDealer(data, index) {
      this.info.dealers[index].id = data.id;
      this.info.dealers[index].name = data.name;
      this.info.dealers[index].leader = data.leader;
      this.info.dealers[index].phone = data.phone;
      this.info.dealers[index].scope = data.scope;
      this.info.dealers[index].address = data.fullAddress + data.address;
      this.info.dealers[index].images = this.separate(data.images);
    },
    separate(arr) {
      return arr.map(element => {
        return element.name;
      });
    },
    addDealer() {
      this.info.dealers.push({
        id: "",
        name: "",
        leader: "",
        phone: "",
        scope: "",
        fullAddress: "",
        images: []
      });
      this.$nextTick(() => {
        let i = this.info.dealers.length - 1;
        window.location.href = `#dealer${i}`;
      });
    },
    //添加质检信息
    addInspect() {
      this.info.qualityInspections.push({
        guid: Utils.guid(),
        inspectionOrganizationId: "",
        inspectionOrganizationName: "",
        inspectionDate: new Date(),
        phone: "",
        address: "",
        images: []
      });
      this.$nextTick(() => {
        let i = this.info.qualityInspections.length - 1;
        window.location.href = `#qualtity${i}`;
      });
    },
    getInspect(data, index) {
      this.info.qualityInspections[index].inspectionOrganizationId =
        data.inspectionOrganizationId;
      this.info.qualityInspections[index].inspectionOrganizationName =
        data.inspectionOrganizationName;
      this.info.qualityInspections[index].inspectionDate = data.inspectionDate;
      this.info.qualityInspections[index].phone = data.phone;
      this.info.qualityInspections[index].address = data.address;
      this.info.qualityInspections[index].images = data.images;
      console.log(123333, this.info.qualityInspections[index].images);
      if (this.info.qualityInspections[index].images.length >= 4) {
        this.isHideUpload = true;
      } else {
        this.isHideUpload = false;
      }
      console.log(this.isHideUpload);
    },
    // 获取塘口
    async changeBase(e) {
      this.info.fishPond = "";
      this.info.cultureInfo.fishPond = "";
      this.info.fishBatchId = "";
      this.info.productName = "";
      this.pondList = await this.getFishPond(e);
      if (this.pondList.length == 0) {
        this.$Alert.info({
          content: "该基地下无塘口",
          duration: 5000,
          status: "error"
        });
        // Message.error("该基地下无塘口");
      } else {
        this.info.fishPond = this.pondList[0].key;
        this.changePond(this.info.fishPond);
      }
    },
    // 查询周期数据
    getCultureCycle(e) {
      let obj = {
        fishPondId: e,
        startDate: this.starts,
        endDate: this.ends,
        cleared: this.cleareds,
        pageIndex: 1,
        pageSize: 10000
      };
      this.getCycleList(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.batchList = rsp.data.list; //周期列表
            this.info.fishBatchId = this.batchList[0].id; //选中第一个
            this.info.submitter = this.loginUser.nickName; //提交人信息
            this.changeCycle(this.batchList[0].id);
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    // 获取周期
    async changePond(e) {
      console.log(456, e);
      this.info.fishBatchId = "";
      this.info.productName = "";
      await this.getCultureCycle(e);
    },
    // 获取品种
    async changeCycle(e) {
      this.info.productId = "";
      this.info.productId = "";
      this.fishList = await this.getPondFishList(e);
      if (this.fishList.length != 0) {
        this.info.productName = this.fishList[0].name;
        this.info.productId = this.fishList[0].id;
      } else {
        this.$Alert.info({
          content: "此塘口当前周期无进苗数据",
          duration: 5000,
          status: "error"
        });
        // Message.error("此塘口当前周期无进苗数据");
      }
    },
    // 切换渔品种
    changeVariety(id) {
      let variety = this.fishList.find(item => {
        return item.id == id;
      });
      this.info.productName = variety.name;
    },
    handlePictureCardPreview() {},
    handleRemove() {},
    provinces() {},

    //保存
    async saveBase(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          for (let i = 0; i < this.info.qualityInspections.length; i++) {
            if (this.info.qualityInspections[i].images.length == 0) {
              Message.error("请先上传质检报告");
              return false;
            } else if (
              this.info.qualityInspections[i].inspectionOrganizationName == ""
            ) {
              Message.error("请先选择质检机构");
              return false;
            }
          }

          for (let i = 0; i < this.info.logistics.length; i++) {
            console.log(111, this.info.logistics[i].baseList.countryName);
            console.log(222, this.info.logistics[i].baseList.countryName1);
            if (this.info.logistics[i].name == "") {
              Message.error("请填写完整的物流信息");
              return false;
            } else if (this.info.logistics[i].startDate == "") {
              Message.error("请先选择出发时间");
              return false;
            } else if (this.info.logistics[i].endDate == "") {
              Message.error("请先选择到达时间");
              return false;
            } else if (this.info.logistics[i].baseList.provinceName == "") {
              Message.error("请先选择起始地");
              return false;
            }
            // else if (this.info.logistics[i].baseList.cityName == "") {
            //   Message.error("请先选择市");
            //   return false;
            // }
            //  else if (
            //   this.info.logistics[i].baseList.countryName == "" ||
            //   this.info.logistics[i].baseList.countryName == null
            // ) {
            //   Message.error("请先选择县");
            //   return false;
            // }
            else if (this.info.logistics[i].baseList.startAddress == "") {
              Message.error("请先输入出发详细地址");
              return false;
            } else if (this.info.logistics[i].baseList.provinceName1 == "") {
              Message.error("请先选择目的地");
              return false;
            }
            // else if (this.info.logistics[i].baseList.cityName1 == "") {
            //   Message.error("请先选择市");
            //   return false;
            // }
            //  else if (
            //   this.info.logistics[i].baseList.countryName1 == "" ||
            //   this.info.logistics[i].baseList.countryName1 == null
            // ) {
            //   Message.error("请先选择县");
            //   return false;
            // }
            else if (this.info.logistics[i].baseList.stopAddress == "") {
              Message.error("请先输入目的地详细地址");
              return false;
            }
          }
          for (let i = 0; i < this.info.dealers.length; i++) {
            if (this.info.dealers[i].name == "") {
              Message.error("请先选择流通商");
              return false;
            }
          }
          if (this.$route.query.traceCode) {
            this.loadingtype = true;
            this.info.code = parseInt(this.$route.query.traceCode);
            // 修改追溯码
            this.editTracingCode(this.info)
              .then(data => {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.loadingtype = false;
                this.$router.push({
                  name: "qualityTracingList"
                });
              })
              .catch(err => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error"
                });
              });
          } else {
            this.loadingtype = true;
            // 获取追溯码
            this.info.code = await this.getQualityTracingCode();
            // 添加追溯码
            console.log(this.info);
            this.addQualityTracing(this.info)
              .then(data => {
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.loadingtype = false;
                this.$router.push({
                  name: "qualityTracingList"
                });
              })
              .catch(err => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error"
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    }
  }
};
</script>
<style lang="stylus">
.addQualityTracing
  
  .addr
    .el-form-item__content
      width:510px;
  .time
    .el-input__inner
      height 44px;
      line-height 44px;
      color:#333;
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .two-row
    display flex;
    .el-form-item
      width:300px;
  .content-form-container
    background #eee
  .el-form-item 
    width 600px;
  .el-input--medium .el-input__inner
    line-height 44px;
    height:44px;
    border: 1px solid #e0e0e0;
    color:#333;
  .el-input.is-disabled .el-input__inner,.el-textarea.is-disabled .el-textarea__inner
    color:#999;
    background-color: #F3F3F3;
  .el-form
  .main-container-form.el-form
    margin:0 !important;
</style>
<style lang="stylus" scoped>
  .main-container-form
    overflow:hidden;
    margin-bottom:10px;
    border:1px solid #e0e0e0;
    background #fff
  .el-form
    position relative
    padding: 28px 0 40px 150px
  .head-title
    line-height:48px;
    font-size:16px;
    background #f7f7f7;
    .titleForm-container
      float left;
      height:48px;
      line-height:48px;
      font-weight: initial;
    .add
      float right;
      margin-right:95px;
      color:#3389FF
      cursor:pointer;
      img 
        margin-right:7px;
        vertical-align: middle;
      span 
        vertical-align: middle;
  .save-cancel
    padding:20px 0 40px 0;
    .el-button
      width:140px;
      border:none;
    .cancel-btn
      border:1px solid #aeaeae;
      background #eee;
</style>
